var map = {
	"./layouts/card": 16,
	"./layouts/card/": 16,
	"./layouts/card/index": 16,
	"./layouts/card/index.tsx": 16,
	"./layouts/card/style.module": 96,
	"./layouts/card/style.module.scss": 96,
	"./layouts/components/breadcrumbs": 123,
	"./layouts/components/breadcrumbs/": 123,
	"./layouts/components/breadcrumbs/index": 123,
	"./layouts/components/breadcrumbs/index.tsx": 123,
	"./layouts/components/breadcrumbs/style.module": 174,
	"./layouts/components/breadcrumbs/style.module.scss": 174,
	"./layouts/components/container": 42,
	"./layouts/components/container/": 42,
	"./layouts/components/container/index": 42,
	"./layouts/components/container/index.tsx": 42,
	"./layouts/components/container/style.module": 125,
	"./layouts/components/container/style.module.scss": 125,
	"./layouts/components/footer": 124,
	"./layouts/components/footer/": 124,
	"./layouts/components/footer/index": 124,
	"./layouts/components/footer/index.tsx": 124,
	"./layouts/components/footer/style.module": 86,
	"./layouts/components/footer/style.module.scss": 86,
	"./layouts/components/loading_indicator": 64,
	"./layouts/components/loading_indicator/": 64,
	"./layouts/components/loading_indicator/index": 64,
	"./layouts/components/loading_indicator/index.tsx": 64,
	"./layouts/components/nav_bar": 95,
	"./layouts/components/nav_bar/": 95,
	"./layouts/components/nav_bar/index": 95,
	"./layouts/components/nav_bar/index.tsx": 95,
	"./layouts/components/nav_bar/standalone": 325,
	"./layouts/components/nav_bar/standalone.tsx": 325,
	"./layouts/components/nav_bar/style.module": 35,
	"./layouts/components/nav_bar/style.module.scss": 35,
	"./layouts/components/notice_banner": 85,
	"./layouts/components/notice_banner/": 85,
	"./layouts/components/notice_banner/assets/sale_tag_icon": 175,
	"./layouts/components/notice_banner/assets/sale_tag_icon.svg": 175,
	"./layouts/components/notice_banner/index": 85,
	"./layouts/components/notice_banner/index.tsx": 85,
	"./layouts/components/notice_banner/standalone": 326,
	"./layouts/components/notice_banner/standalone.tsx": 326,
	"./layouts/components/notice_banner/style.module": 176,
	"./layouts/components/notice_banner/style.module.scss": 176,
	"./layouts/page": 93,
	"./layouts/page/": 93,
	"./layouts/page/index": 93,
	"./layouts/page/index.tsx": 93,
	"./layouts/page/style.module": 87,
	"./layouts/page/style.module.scss": 87,
	"./layouts/types": 327,
	"./layouts/types.ts": 327,
	"./marketing/pages/home/ielts": 1602,
	"./marketing/pages/home/ielts/": 1602,
	"./marketing/pages/home/ielts/assets/avatars": 1855,
	"./marketing/pages/home/ielts/assets/avatars.png": 1855,
	"./marketing/pages/home/ielts/index": 1602,
	"./marketing/pages/home/ielts/index.tsx": 1602,
	"./marketing/pages/home/ielts/sections/ai": 1198,
	"./marketing/pages/home/ielts/sections/ai/": 1198,
	"./marketing/pages/home/ielts/sections/ai/assets/ai_coaching_feature": 1830,
	"./marketing/pages/home/ielts/sections/ai/assets/ai_coaching_feature.png": 1830,
	"./marketing/pages/home/ielts/sections/ai/assets/ai_explanations_feature": 1831,
	"./marketing/pages/home/ielts/sections/ai/assets/ai_explanations_feature.png": 1831,
	"./marketing/pages/home/ielts/sections/ai/assets/ai_speaking_grading_feature": 1832,
	"./marketing/pages/home/ielts/sections/ai/assets/ai_speaking_grading_feature.png": 1832,
	"./marketing/pages/home/ielts/sections/ai/assets/ai_writing_grading_feature": 1833,
	"./marketing/pages/home/ielts/sections/ai/assets/ai_writing_grading_feature.png": 1833,
	"./marketing/pages/home/ielts/sections/ai/assets/sparkle_bg": 1834,
	"./marketing/pages/home/ielts/sections/ai/assets/sparkle_bg.svg": 1834,
	"./marketing/pages/home/ielts/sections/ai/assets/sparkle_icon": 1835,
	"./marketing/pages/home/ielts/sections/ai/assets/sparkle_icon.svg": 1835,
	"./marketing/pages/home/ielts/sections/ai/index": 1198,
	"./marketing/pages/home/ielts/sections/ai/index.tsx": 1198,
	"./marketing/pages/home/ielts/sections/ai/style.module": 1836,
	"./marketing/pages/home/ielts/sections/ai/style.module.scss": 1836,
	"./marketing/pages/home/ielts/sections/apps": 1199,
	"./marketing/pages/home/ielts/sections/apps/": 1199,
	"./marketing/pages/home/ielts/sections/apps/assets/app_store_icon": 1837,
	"./marketing/pages/home/ielts/sections/apps/assets/app_store_icon.svg": 1837,
	"./marketing/pages/home/ielts/sections/apps/assets/device_icon": 1838,
	"./marketing/pages/home/ielts/sections/apps/assets/device_icon.svg": 1838,
	"./marketing/pages/home/ielts/sections/apps/assets/flashcard_app": 1839,
	"./marketing/pages/home/ielts/sections/apps/assets/flashcard_app.png": 1839,
	"./marketing/pages/home/ielts/sections/apps/assets/play_store_icon": 1840,
	"./marketing/pages/home/ielts/sections/apps/assets/play_store_icon.svg": 1840,
	"./marketing/pages/home/ielts/sections/apps/assets/prep_app": 1841,
	"./marketing/pages/home/ielts/sections/apps/assets/prep_app.png": 1841,
	"./marketing/pages/home/ielts/sections/apps/index": 1199,
	"./marketing/pages/home/ielts/sections/apps/index.tsx": 1199,
	"./marketing/pages/home/ielts/sections/features": 1200,
	"./marketing/pages/home/ielts/sections/features/": 1200,
	"./marketing/pages/home/ielts/sections/features/assets/analytics_feature": 1842,
	"./marketing/pages/home/ielts/sections/features/assets/analytics_feature.png": 1842,
	"./marketing/pages/home/ielts/sections/features/assets/practice_tests_feature": 1843,
	"./marketing/pages/home/ielts/sections/features/assets/practice_tests_feature.png": 1843,
	"./marketing/pages/home/ielts/sections/features/assets/score_predictor_feature": 1844,
	"./marketing/pages/home/ielts/sections/features/assets/score_predictor_feature.png": 1844,
	"./marketing/pages/home/ielts/sections/features/assets/star_icon": 1845,
	"./marketing/pages/home/ielts/sections/features/assets/star_icon.svg": 1845,
	"./marketing/pages/home/ielts/sections/features/assets/student_help_feature": 1846,
	"./marketing/pages/home/ielts/sections/features/assets/student_help_feature.png": 1846,
	"./marketing/pages/home/ielts/sections/features/index": 1200,
	"./marketing/pages/home/ielts/sections/features/index.tsx": 1200,
	"./marketing/pages/home/ielts/sections/value_props": 1201,
	"./marketing/pages/home/ielts/sections/value_props/": 1201,
	"./marketing/pages/home/ielts/sections/value_props/assets/concentric_circles": 1847,
	"./marketing/pages/home/ielts/sections/value_props/assets/concentric_circles.svg": 1847,
	"./marketing/pages/home/ielts/sections/value_props/assets/magic_wand_icon": 1848,
	"./marketing/pages/home/ielts/sections/value_props/assets/magic_wand_icon.svg": 1848,
	"./marketing/pages/home/ielts/sections/value_props/index": 1201,
	"./marketing/pages/home/ielts/sections/value_props/index.tsx": 1201,
	"./marketing/pages/home/ielts/sections/value_props/style.module": 2306,
	"./marketing/pages/home/ielts/sections/value_props/style.module.scss": 2306,
	"./marketing/pages/home/ielts/sections/video_based_learning": 1202,
	"./marketing/pages/home/ielts/sections/video_based_learning/": 1202,
	"./marketing/pages/home/ielts/sections/video_based_learning/assets/eliot_headshot": 1849,
	"./marketing/pages/home/ielts/sections/video_based_learning/assets/eliot_headshot.png": 1849,
	"./marketing/pages/home/ielts/sections/video_based_learning/assets/focused_lesson_card": 1850,
	"./marketing/pages/home/ielts/sections/video_based_learning/assets/focused_lesson_card.png": 1850,
	"./marketing/pages/home/ielts/sections/video_based_learning/assets/lesson_cards_bg": 1851,
	"./marketing/pages/home/ielts/sections/video_based_learning/assets/lesson_cards_bg.png": 1851,
	"./marketing/pages/home/ielts/sections/video_based_learning/assets/play_icon": 1852,
	"./marketing/pages/home/ielts/sections/video_based_learning/assets/play_icon.svg": 1852,
	"./marketing/pages/home/ielts/sections/video_based_learning/assets/video_thumbnail": 1853,
	"./marketing/pages/home/ielts/sections/video_based_learning/assets/video_thumbnail.png": 1853,
	"./marketing/pages/home/ielts/sections/video_based_learning/index": 1202,
	"./marketing/pages/home/ielts/sections/video_based_learning/index.tsx": 1202,
	"./marketing/pages/home/ielts/sections/video_based_learning/style.module": 757,
	"./marketing/pages/home/ielts/sections/video_based_learning/style.module.scss": 757,
	"./marketing/pages/home/ielts/sections/wall_of_love": 1203,
	"./marketing/pages/home/ielts/sections/wall_of_love/": 1203,
	"./marketing/pages/home/ielts/sections/wall_of_love/assets/waqeeb_headshot": 1854,
	"./marketing/pages/home/ielts/sections/wall_of_love/assets/waqeeb_headshot.png": 1854,
	"./marketing/pages/home/ielts/sections/wall_of_love/index": 1203,
	"./marketing/pages/home/ielts/sections/wall_of_love/index.tsx": 1203,
	"./marketing/pages/home/ielts/style.module": 1856,
	"./marketing/pages/home/ielts/style.module.scss": 1856,
	"./marketing/pages/plans/ielts": 1603,
	"./marketing/pages/plans/ielts/": 1603,
	"./marketing/pages/plans/ielts/index": 1603,
	"./marketing/pages/plans/ielts/index.tsx": 1603,
	"./marketing/pages/plans/ielts/sections/testimonials": 1204,
	"./marketing/pages/plans/ielts/sections/testimonials/": 1204,
	"./marketing/pages/plans/ielts/sections/testimonials/assets/neha_headshot": 1857,
	"./marketing/pages/plans/ielts/sections/testimonials/assets/neha_headshot.png": 1857,
	"./marketing/pages/plans/ielts/sections/testimonials/assets/saurav_headshot": 1858,
	"./marketing/pages/plans/ielts/sections/testimonials/assets/saurav_headshot.png": 1858,
	"./marketing/pages/plans/ielts/sections/testimonials/index": 1204,
	"./marketing/pages/plans/ielts/sections/testimonials/index.tsx": 1204
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2651;